import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useUpdateAdUnit = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateAdUnitHook = async (ad_unit, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.put(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-ad-unit-service/v1/update/`,
        {ad_unit}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to update ad unit");
      }
      
    } catch (error) {
      setError("An error occurred while creating the ad unit");
    } finally {
      setLoading(false);
    }
  };

  return [ updateAdUnitHook, loading, error, success ];
};